export const FETCH_EXPENSES = 'DETALIZATION_NEW:FETCH_EXPENSES';
export const FETCH_EXPENSES_SUCCESS = 'DETALIZATION_NEW:FETCH_EXPENSES_SUCCESS';
export const FETCH_EXPENSES_ERROR = 'DETALIZATION_NEW:FETCH_EXPENSES_ERROR';
export const FETCH_EXPENSES_SERVER_ERROR = 'DETALIZATION_NEW:FETCH_EXPENSES_SERVER_ERROR';

export const FILTER_ACCUMULATORS = 'DETALIZATION_NEW:FILTER_ACCUMULATORS';
export const TOGGLE_TABS = 'DETALIZATION_NEW:TOGGLE_TABS';
export const TOGGLE_ROAMING = 'DETALIZATION_NEW:TOGGLE_ROAMING';
export const FILTER_PATH_CTN = 'DETALIZATION_NEW:FILTER_PATH_CTN';

export const TABLE_FILTERS = 'DETALIZATION_NEW:TABLE_FILTERS';
export const TABLE_FILTERS_CLEAR = 'DETALIZATION_NEW:TABLE_FILTERS_CLEAR';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const UI_DATE_FORMAT = 'DD.MM.YY';

const newAccum = (id, color = null, children = []) => ({ id, color, children });
export const ACCUMULATOR_TREE = newAccum('ROOT', null, [
  newAccum('INTERNATIONAL_ROAMING', 'green', [
    newAccum('INTERNATIONAL_ROAMING_INTERNET'),
    newAccum('INTERNATIONAL_ROAMING_INCOMING_CALLS'),
    newAccum('INTERNATIONAL_ROAMING_OUTCOMING_CALLS'),
    newAccum('INTERNATIONAL_ROAMING_SMS_MMS'),
    newAccum('INTERNATIONAL_ROAMING_INCOMING_SMS_MMS'),
  ]),
  newAccum('LOCAL', 'pink', [
    newAccum('LOCAL_INTERNET_ND', 'red'),
    newAccum('LOCAL_INCOMING_CALLS'),
    newAccum('LOCAL_OUTCOMING_CALLS', 'violet', [
      newAccum('INTERNATIONAL_CALLS_ND'),
      newAccum('LOCAL_OUTCOMING_CALLS_RUSSIA'),
    ]),
    newAccum('LOCAL_OUTCOMING_SMS_MMS', 'yellow', [
      newAccum('INTERNATIONAL_SMS_MMS_ND'),
      newAccum('SMS_MMS_RUSSIA'),
    ]),
    newAccum('LOCAL_INCOMING_SMS_MMS'),
  ]),
  newAccum('SUBSCRIBER_FEE_AND_SERVICE_CHANGE_FEE', 'blue', []),
  newAccum('TVE_CHARGE', 'orange', []),
  newAccum('INFO_ENTERTAINMENT', 'pink', []),
  newAccum('SERVICES_PAYMENTS_AND_MOBILE_TRANSFERS', 'purple', [
    newAccum('MOBILE_TRANSFER'),
    newAccum('SERVICES_PAYMENTS_AND_MOBILE_COMMERCE'),
    newAccum('TRUSTED_AND_AUTO_PAYMENTS'),
  ]),
  newAccum('OTHER_CHARGES', 'indigo', []),
]);

export const ACCUMULATOR_TREE_LINKS = {};

const walkAccumTree = (root) => {
  ACCUMULATOR_TREE_LINKS[root.id] = root;
  root.children.forEach(walkAccumTree);
};
walkAccumTree(ACCUMULATOR_TREE);

export const MODIFY_CTN_CARD = {
  LOCAL_INTERNET_ND:
    {
      path: '/detalization/data',
      pathName: 'К статистике трафика',
      img: 'https://static.beeline.ru/upload/images/detalization/icon_internet_detalization.svg',
      defaultUnit: 'кб',
      defaultTitle: 'Интернет',
    },
  LOCAL_OUTCOMING_CALLS:
    {
      path: '/detalization/call',
      pathName: 'К статистике звонков',
      img: 'https://static.beeline.ru/upload/images/detalization/icon_call_detalization.svg',
      defaultUnit: 'сек',
      defaultTitle: 'Звонки',
    },
  LOCAL_OUTCOMING_SMS_MMS:
    {
      path: '/detalization/sms',
      pathName: 'К статистике сообщений',
      img: 'https://static.beeline.ru/upload/images/detalization/icon_sms_detalization.svg',
      defaultUnit: 'SMS',
      defaultTitle: 'Сообщения',
    },
  INTERNATIONAL_ROAMING_INTERNET:
    {
      path: '/detalization/roaming/data',
      pathName: 'К статистике трафика',
      img: 'https://static.beeline.ru/upload/images/detalization/icon_internet_detalization.svg',
      defaultUnit: 'кб',
      defaultTitle: 'Интернет',
    },
  INTERNATIONAL_ROAMING_OUTCOMING_CALLS:
    {
      path: '/detalization/roaming/call',
      pathName: 'К статистике звонков',
      img: 'https://static.beeline.ru/upload/images/detalization/icon_call_detalization.svg',
      defaultUnit: 'сек',
      defaultTitle: 'Звонки',
    },
  INTERNATIONAL_ROAMING_SMS_MMS:
    {
      path: '/detalization/roaming/sms',
      pathName: 'К статистике сообщений',
      img: 'https://static.beeline.ru/upload/images/detalization/icon_sms_detalization.svg',
      defaultUnit: 'SMS',
      defaultTitle: 'Сообщения',
    },
};

export const UNIT_REPLACE_TEXT = {
  KBYTE: 'гб',
  SECONDS: 'мин',
  PIECE: 'СМС',
};

export const SORT_CTN_BLOCK = {
  LOCAL_INTERNET_ND: 1,
  LOCAL_OUTCOMING_CALLS: 2,
  LOCAL_OUTCOMING_SMS_MMS: 3,
  INTERNATIONAL_ROAMING_INTERNET: 1,
  INTERNATIONAL_ROAMING_SMS_MMS: 3,
  INTERNATIONAL_ROAMING_OUTCOMING_CALLS: 2,
};
